import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

let i18n;

export function setLocale(locale) {
  setupI18n();
  i18n.locale = locale;
}

export function translate(key, params = {}) {
  setupI18n();
  let message = key;

  try {
    message = i18n.t(key, params);
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
  }

  return message;
}

export default function setupI18n() {
  if (!i18n) {
    i18n = new VueI18n({
      locale: process.env.VUE_APP_I18N_LOCALE || 'ru',
      fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ru',
      messages: loadLocaleMessages()
    });
  }

  return i18n;
}

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}
